import styled from "styled-components";
import {
  blueColor,
  goldColor,
  // primaryColor,
  whiteColor,
} from "../../../styled/Theme";
import { FLogoSVG, YoyaSVG } from "../../../../assets/svg/SvgIcons";
import { currentYear } from "../../../../utils/helpers";
import { APP_NAME } from "../../../../utils/constants";
import { Link } from "react-router-dom";
import {
  Facebook,
  LinkedIn,
  X,
  Email,
  Phone,
  LocationOn,
  ArrowForward,
  Security,
  Verified,
  ArrowRightAlt,
} from "@mui/icons-material";
import {
  URL_APPLY_AS_AGENT,
  URL_APPLY_AS_MERCHANT,
} from "../../../../utils/urls";

const Footer = () => {
  return (
    <Wrapper id="footer">
      {/* ── CTA pre-footer band ── */}
      <CTABand>
        <CTABandInner className="container">
          <CTALeft>
            <CTAEyebrow>Get Started Today</CTAEyebrow>
            <CTAHeadline>Ready to simplify your payments?</CTAHeadline>
          </CTALeft>
          <CTARight>
            <CTAPrimary to="/contact">
              Talk to our team <ArrowRightAlt fontSize="small" />
            </CTAPrimary>
            <CTASecondary to="/products-services#goods-services">
              Explore products
            </CTASecondary>
          </CTARight>
        </CTABandInner>
      </CTABand>

      {/* ── Main footer grid ── */}
      <MainFooter>
        <GridWrapper className="container">
          {/* Brand col */}
          <BrandSection data-aos="fade-up" data-aos-delay="0">
            <LogoContainer>
              <Link to="/">
                <img
                  src={FLogoSVG}
                  height={30}
                  alt={APP_NAME}
                  style={{ filter: "brightness(10)" }}
                />
              </Link>
            </LogoContainer>

            <BrandDesc>
              Delivering modern, secure, and scalable digital solutions that
              simplify communication, accelerate financial inclusion, and unlock
              growth for everyone.
            </BrandDesc>

            <SocialRow>
              <SocialIcon href="#" aria-label="Facebook">
                <Facebook sx={{ fontSize: 18 }} />
              </SocialIcon>
              <SocialIcon href="#" aria-label="Twitter / X">
                <X sx={{ fontSize: 18 }} />
              </SocialIcon>
              <SocialIcon href="#" aria-label="LinkedIn">
                <LinkedIn sx={{ fontSize: 18 }} />
              </SocialIcon>
            </SocialRow>

            <TrustBadge data-aos="fade-up" data-aos-delay="200">
              <Verified sx={{ fontSize: 16, color: goldColor }} />
              <TrustBadgeText>Powered by</TrustBadgeText>
              <img alt="yoya" src={YoyaSVG} height={32} />
            </TrustBadge>
          </BrandSection>

          {/* Products */}
          <LinksSection data-aos="fade-up" data-aos-delay="80">
            <ColHeader>Products</ColHeader>
            <LinksList>
              {[
                { label: "Pay Bills", to: "/products-services#pay-bills" },
                {
                  label: "Street Parking",
                  to: "/products-services#street-parking",
                },
                {
                  label: "Goods & Services",
                  to: "/products-services#goods-services",
                },
                { label: "Fees & Taxes", to: "/products-services#fees-taxes" },
                {
                  label: "Financial Services",
                  to: "/products-services#financial-services",
                },
              ].map((l) => (
                <FooterLink key={l.label} to={l.to}>
                  <LinkArrow className="arrow">
                    <ArrowForward sx={{ fontSize: 12 }} />
                  </LinkArrow>
                  {l.label}
                </FooterLink>
              ))}
            </LinksList>
          </LinksSection>

          {/* Company */}
          <LinksSection data-aos="fade-up" data-aos-delay="160">
            <ColHeader>Company</ColHeader>
            <LinksList>
              {[
                { label: "About Us", to: "/about#about" },
                { label: "Mission & Vision", to: "/about#mission-vision" },
                { label: "Our Impact", to: "/about#our-impact" },
                { label: "Developers", to: "/developers" },
                { label: "Help Desk", to: "/contact" },
              ].map((l) => (
                <FooterLink key={l.label} to={l.to}>
                  <LinkArrow className="arrow">
                    <ArrowForward sx={{ fontSize: 12 }} />
                  </LinkArrow>
                  {l.label}
                </FooterLink>
              ))}
            </LinksList>
          </LinksSection>

          {/* Join Us */}
          <LinksSection data-aos="fade-up" data-aos-delay="240">
            <ColHeader>Join Us</ColHeader>
            <LinksList>
              <JoinCard to={URL_APPLY_AS_MERCHANT}>
                <JoinCardLabel>Become a Merchant</JoinCardLabel>
                <JoinCardSub>Accept digital payments instantly</JoinCardSub>
                <ArrowRightAlt sx={{ fontSize: 16, color: goldColor }} />
              </JoinCard>
              <JoinCard to={URL_APPLY_AS_AGENT}>
                <JoinCardLabel>Become an Agent</JoinCardLabel>
                <JoinCardSub>Serve your community with OnePayX</JoinCardSub>
                <ArrowRightAlt sx={{ fontSize: 16, color: goldColor }} />
              </JoinCard>
            </LinksList>
          </LinksSection>

          {/* Contact */}
          <ContactSection data-aos="fade-up" data-aos-delay="320">
            <ColHeader>Contact Us</ColHeader>
            <ContactList>
              <ContactItem>
                <ContactIconWrap>
                  <Phone sx={{ fontSize: 15 }} />
                </ContactIconWrap>
                <ContactText>
                  <ContactLabel>Support Line</ContactLabel>
                  <ContactValue>0800-334-335</ContactValue>
                </ContactText>
              </ContactItem>

              <ContactItem>
                <ContactIconWrap>
                  <Email sx={{ fontSize: 15 }} />
                </ContactIconWrap>
                <ContactText>
                  <ContactLabel>Email</ContactLabel>
                  <ContactValue>info@{APP_NAME.toLowerCase()}.net</ContactValue>
                </ContactText>
              </ContactItem>

              <ContactItem>
                <ContactIconWrap>
                  <LocationOn sx={{ fontSize: 15 }} />
                </ContactIconWrap>
                <ContactText>
                  <ContactLabel>Location</ContactLabel>
                  <ContactValue>
                    Plot 38 Friendship Road, Ntinda
                    <br />
                    P.O.Box 121587, Kampala, Uganda
                  </ContactValue>
                </ContactText>
              </ContactItem>
            </ContactList>
          </ContactSection>
        </GridWrapper>
      </MainFooter>

      {/* ── Bottom bar ── */}
      <BottomBar>
        <BottomBarInner className="container">
          <Copyright>
            <Security sx={{ fontSize: 14 }} />
            &copy; {currentYear()} YOYA Technologies. All Rights Reserved.
          </Copyright>
          <BottomDivider />
          <LegalLinks>
            <LegalLink to="/legal">Privacy Policy</LegalLink>
            <LegalDot>•</LegalDot>
            <LegalLink to="/legal">Terms of Service</LegalLink>
            <LegalDot>•</LegalDot>
            <LegalLink to="/legal">Cookie Policy</LegalLink>
          </LegalLinks>
        </BottomBarInner>
      </BottomBar>

      {/* decorative background glows */}
      <BgGlow1 />
      <BgGlow2 />
    </Wrapper>
  );
};

export default Footer;

/* ── Styled Components ── */

const Wrapper = styled.footer`
  background: ${blueColor};
  color: ${whiteColor};
  position: relative;
  overflow: hidden;
`;

/* Decorative glows */
const BgGlow1 = styled.div`
  position: absolute;
  top: 40px;
  right: -80px;
  width: 360px;
  height: 360px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.04) 0%,
    transparent 70%
  );
  pointer-events: none;
`;

const BgGlow2 = styled.div`
  position: absolute;
  bottom: 60px;
  left: -60px;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: radial-gradient(circle, ${goldColor}10 0%, transparent 70%);
  pointer-events: none;
`;

/* CTA Band */
const CTABand = styled.div`
  background: rgba(0, 0, 0, 0.18);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  z-index: 1;
`;

const CTABandInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 28px 20px;
  flex-wrap: wrap;
`;

const CTALeft = styled.div``;

const CTAEyebrow = styled.div`
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${goldColor};
  margin-bottom: 4px;
`;

const CTAHeadline = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.3px;
`;

const CTARight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const CTAPrimary = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${goldColor};
  color: #0a1628;
  font-size: 13.5px;
  font-weight: 700;
  border-radius: 10px;
  padding: 10px 20px;
  text-decoration: none;
  transition: all 0.22s;

  &:hover {
    background: #e6a800;
    gap: 10px;
  }
`;

const CTASecondary = styled(Link)`
  display: inline-flex;
  align-items: center;
  font-size: 13.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 10px 18px;
  transition: all 0.22s;

  &:hover {
    color: #fff;
    border-color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.06);
  }
`;

/* Main footer */
const MainFooter = styled.div`
  position: relative;
  z-index: 1;
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr 1.3fr;
  gap: 2.5rem;
  padding: 56px 20px 48px;

  @media (max-width: 1200px) {
    grid-template-columns: 1.4fr repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    padding: 40px 20px 32px;
  }
`;

/* Brand */
const BrandSection = styled.div``;

const LogoContainer = styled.div`
  margin-bottom: 16px;
`;

const BrandDesc = styled.p`
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.75;
  margin: 0 0 20px;
`;

const SocialRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
`;

const SocialIcon = styled.a`
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  transition: all 0.22s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    transform: translateY(-2px);
    border-color: rgba(255, 255, 255, 0.25);
  }
`;

const TrustBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 10px 14px;
`;

const TrustBadgeText = styled.span`
  font-size: 10.5px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

/* Links col */
const LinksSection = styled.div``;

const ColHeader = styled.h4`
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 20px;
  letter-spacing: 0.2px;
  position: relative;
  padding-bottom: 10px;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 24px;
    height: 2px;
    background: ${goldColor};
    border-radius: 2px;
  }
`;

const LinksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const LinkArrow = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${goldColor};
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition: all 0.22s;
  flex-shrink: 0;
`;

const FooterLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0;
  color: rgba(255, 255, 255, 0.65);
  text-decoration: none;
  font-size: 13.5px;
  padding: 5px 0;
  transition: all 0.22s;

  &:hover {
    color: #ffffff;
    gap: 6px;

    ${LinkArrow} {
      opacity: 1;
      width: 16px;
    }
  }
`;

/* Join cards */
const JoinCard = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 14px 16px;
  text-decoration: none;
  margin-bottom: 10px;
  transition: all 0.22s;
  position: relative;

  svg {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    transition: right 0.22s;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: ${goldColor}50;

    svg {
      right: 10px;
    }
  }
`;

const JoinCardLabel = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
`;

const JoinCardSub = styled.div`
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.4;
`;

/* Contact */
const ContactSection = styled.div``;

const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const ContactIconWrap = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${goldColor};
  flex-shrink: 0;
  margin-top: 1px;
`;

const ContactText = styled.div``;

const ContactLabel = styled.div`
  font-size: 10.5px;
  color: rgba(255, 255, 255, 0.42);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 2px;
`;

const ContactValue = styled.div`
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.5;
`;

/* Bottom bar */
const BottomBar = styled.div`
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  z-index: 1;
`;

const BottomBarInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }
`;

const Copyright = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.45);

  svg {
    color: rgba(255, 255, 255, 0.35);
  }
`;

const BottomDivider = styled.div`
  flex: 1;

  @media (max-width: 600px) {
    display: none;
  }
`;

const LegalLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
`;

const LegalLink = styled(Link)`
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.45);
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: rgba(255, 255, 255, 0.85);
  }
`;

const LegalDot = styled.span`
  color: rgba(255, 255, 255, 0.2);
  font-size: 10px;
`;
